var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDisclaimerIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.875 8.69373C2.875 9.48166 3.03019 10.2619 3.33172 10.9898C3.63325 11.7178 4.07521 12.3792 4.63236 12.9364C5.18951 13.4935 5.85095 13.9355 6.5789 14.237C7.30685 14.5385 8.08707 14.6937 8.875 14.6937C9.66293 14.6937 10.4431 14.5385 11.1711 14.237C11.8991 13.9355 12.5605 13.4935 13.1176 12.9364C13.6748 12.3792 14.1167 11.7178 14.4183 10.9898C14.7198 10.2619 14.875 9.48166 14.875 8.69373C14.875 7.90579 14.7198 7.12558 14.4183 6.39763C14.1167 5.66967 13.6748 5.00824 13.1176 4.45108C12.5605 3.89393 11.8991 3.45198 11.1711 3.15045C10.4431 2.84892 9.66293 2.69373 8.875 2.69373C8.08707 2.69373 7.30685 2.84892 6.5789 3.15045C5.85095 3.45198 5.18951 3.89393 4.63236 4.45108C4.07521 5.00824 3.63325 5.66967 3.33172 6.39763C3.03019 7.12558 2.875 7.90579 2.875 8.69373Z",
    stroke: "#AE8951",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.875 6.69373V9.36039",
    stroke: "#AE8951",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.875 11.3604V11.3671",
    stroke: "#AE8951",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDisclaimerIcon);
export default __webpack_public_path__ + "static/media/disclaimer_icon.0fa1d1e6eb2a7c39b323c38956b0dbe1.svg";
export { ForwardRef as ReactComponent };